import Layout2 from '@/layout/Layout2'
import { RouterTabRoutes } from 'vue-router-tab'

export default [{
  path: '/Business',
  component: Layout2,
  children: [
    ...RouterTabRoutes,
    {
      path: 'Study/Teacher',
      meta: { title: '教师管理' },
      component: () => import('@/components/Business/Study/Teacher')
    },
    {
      path: 'Study/Users',
      meta: { title: '用户管理' },
      component: () => import('@/components/Business/Study/Users')
    },
    {
      path: 'Study/Trainees',
      meta: { title: '学员管理' },
      component: () => import('@/components/Business/Study/Trainees')
    },
    {
      path: 'Study/Course',
      meta: { title: '课程管理' },
      component: () => import('@/components/Business/Study/Course')
    },
    {
      path: 'Study/CourseClass',
      meta: { title: '校区课程管理' },
      component: () => import('@/components/Business/Study/CourseClass')
    },
    {
      path: 'Study/Order',
      meta: { title: '订单管理' },
      component: () => import('@/components/Business/Study/Order')
    },
    {
      path: 'Study/SmsRecord',
      meta: { title: '短信发送记录' },
      component: () => import('@/components/Business/Study/SmsRecord')
    },
    {
      path: 'Study/Picture',
      meta: { title: '轮播图片' },
      component: () => import('@/components/Business/Study/Picture')
    }]
}]
